export default __webpack_public_path__ + "locales/ko-KR/FormGallery.json?hash=96a2539623af55c1946177c6b290389a";